import { render } from "./SideMenuComponent.vue?vue&type=template&id=5f136a7d"
import script from "./SideMenuComponent.vue?vue&type=script&lang=js"
export * from "./SideMenuComponent.vue?vue&type=script&lang=js"

import "./SideMenuComponent.vue?vue&type=style&index=0&id=5f136a7d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__